export default __webpack_public_path__ + "static/media/busd.b78b8434.svg";